module.exports = __webpack_public_path__ + "img/location.6883a60b.svg";